import { GroupMemberRole } from '../enums/group-member-role.enum';

export const groupMemberRoleNames: Record<GroupMemberRole, string> = {
    [GroupMemberRole.ALL]: 'group.members.role.all',
    [GroupMemberRole.PI]: 'group.members.role.pi',
    [GroupMemberRole.GROUP_MANAGER]: 'group.members.role.groupManager',
    [GroupMemberRole.RESEARCHER]: 'group.members.role.researcher',
};
